import type { ReactNode } from 'react';

import { getAppletsUrl } from '@cartwhl/common/utils';
import GoButton from '@cartwhl/ui/input/GoButton';

interface ScalingLawsCTAProps {
  children?: ReactNode;
}

export default function ScalingLawsCTA({
  children = 'Read the paper',
}: ScalingLawsCTAProps) {
  return (
    <p className="mb-8">
      <a
        href={`https://github.com/cartwhl/scaling-laws-for-motion`}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline hover:no-underline"
      >
        <GoButton variant="animate" className="px-10">
          {children}
        </GoButton>
      </a>
    </p>
  );
}
